<div class="tt-l-masonry" :style="layoutStyles">
  <slot></slot>
</div>